import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ynToBool from 'Utils/ynToBool';
import {
  loadUserGroupsParticipant,
  loadSubsegmentGroups,
  loadWalletIsManager,
} from 'redux/Reducers/Spot/spotGroupsSlice';

const SpotPermissions = ({ children }) => {
  const dispatch = useDispatch();
  const userInfos = useSelector(({ oidc }) => oidc);

  useEffect(() => {
    if (userInfos.isLoaded) {
      loadUserGroups();
    }
  }, [userInfos.isLoaded]);

  useEffect(() => {
    if (
      userInfos.isLoaded &&
      ynToBool(process.env.REACT_APP_ENABLED_GENERIC_SUPPLIER)
    ) {
      dispatch(loadSubsegmentGroups());
      if (ynToBool(process.env.REACT_APP_HAS_HIERARCHY_VALIDATION)) {
        dispatch(loadWalletIsManager());
      }
    }
  }, [userInfos.isLoaded]);

  const loadUserGroups = async () => {
    if (ynToBool(process.env.REACT_APP_GET_PARTICIPANT_GROUPS)) {
      dispatch(loadUserGroupsParticipant());
    }
  };

  return <>{children}</>;
};

export default SpotPermissions;
